import { groupStream } from '../group/stream';
import { todoRealm } from '../realm';
import { string } from '@iwentsourcing/core/typing/string.js';
import { date } from '@iwentsourcing/core/typing/date.js';
import { boolean } from '@iwentsourcing/core/typing/boolean.js';
import { optional } from '@iwentsourcing/core/typing/optional.js';
import { declareState } from '@iwentsourcing/core/storage/declare-state.js';
import { defineAggregation } from '@iwentsourcing/core/aggregation/define-aggregation.js';
import { injectEvent } from '@iwentsourcing/core/aggregation/inject-event.js';
import { defineState } from '@iwentsourcing/core/storage/define-state.js';
import { TypeOfEvent } from '@iwentsourcing/core/typing/type-of.js';

const TodoGroup = declareState(
  'groups',
  {
    id: string(),
    name: string(),
    createdAt: date(),
    accepted: optional(boolean()),
  },
  ['id'] as const,
).index('name', ['name']);

export type TodoGroup = TypeOfEvent<typeof TodoGroup>;

const aggState = defineState([TodoGroup]);

export const personalGroupAggregation = defineAggregation(todoRealm, {
  pattern: 'groups-$(auth.sub)',
  state: aggState,
  auth: { allowAnonymous: false },
  events: {
    'accept-invite': injectEvent(groupStream, 'accept-invite'),
    'create-group': injectEvent(groupStream, 'create-group'),
  },
  handle: {
    'create-group': (evt, ctx) => {
      ctx.state('groups').insert({
        id: evt.groupId,
        name: evt.name,
        createdAt: ctx.metadata.createdAt,
        accepted: false,
      });
    },
    'accept-invite': (evt, ctx) => {
      ctx.state('groups').patch({
        id: evt.groupId,
        accepted: true,
      });
    },
  },
});
